import { useState } from 'react';
import { Button, Modal, Typography } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import Message from '../../../../config/Message';
import { Notification } from '../../../../config/Global';
const { Title } = Typography;

const CancelBookingComponent = observer((props) => {
	const { visible, onClose } = props;
	const [saving, setSaving] = useState();
	const { PLATFORMBOOKING } = useStore();

	const cancelBooking = () => {
		setSaving(true);
		PLATFORMBOOKING.cancelBooking({
			id: visible.id.toString(),
			versionNo: visible.versionNo,
		})
			.then((msg) => {
				Notification.success({
					message: 'Booking cancelled successfully',
				});
				onClose();
			})
			.catch((e) => {
				Notification.error({
					message: 'Something Wrong',
				});
			})
			.finally(() => setSaving(false));
	};

	return (
		<Modal
			title="Delete Temple"
			onCancel={onClose}
			open={visible}
			destroyOnClose
			width={'450px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						loading={saving}
						onClick={cancelBooking}
					>
						Cancel Booking
					</Button>
					<Button key={2} onClick={onClose}>
						Close
					</Button>
				</div>
			}
		>
			<Title level={5}>
				Are you sure you want to Cancel
				<b>{' ' + visible?.bookingNo + ' - ' + visible.name}'s</b> booking?
			</Title>
		</Modal>
	);
});

export default CancelBookingComponent;
